<template>
	<section class="bg-gray50 pt-0" style="padding-top: 0.02px;">
		<div class="row mb-80" style="margin-top: -223px;">
			<div class="column twelve">
				<div class="relative flex justify-center">
					<div class="ml-30" v-if="logoutUrl">
						<a :href="logoutUrl" class="outlined-button text-center text-blue900 border-white-30">
							<span class="outlined-button-content text-white">Logout</span>
						</a>
					</div>
				</div>
			</div>
		</div>

		<SearchProperties
			ref="searchProperties"
			:initial-search="searchValue"
			:initial-type="type"
			:initial-community="community"
			:window-size="windowSize"
			:params="params"
			@updateSearchParams="params = $event"
		/>

		<div class="flex w-full mx-auto px-40 mt-40 mb-65 md:my-40 justify-between items-center flex-wrap lg:flex-no-wrap gap-x-8">
		    <!-- View Toggle -->
			<toggle :options="toggleOptions" :toggledOption="view" @switch-toggle="view = $event" />

			<!-- Sort -->
			<div class="flex items-center justify-center flex-wrap  lg:flex-no-wrap lg:justify-start w-full lg:w-auto mb-25 lg:mb-0">
				<div class="text-xs font-secondary font-bold uppercase tracking-loose lg:mr-15 w-full lg:w-auto text-center">Sort by:</div>

				<!-- Sort Options -->
				<vSelect :options="sortOptions" v-model="sortOption" :hideDefault="true" class="mr-15 custom-select-borderless" />

				<!-- Sort Direction -->
				<vSelect :options="sortDirections" v-model="sortDirection" :hideDefault="true" class="custom-select-borderless" />

				<button
					v-if="hasActiveFilters"
					class="text-xs font-secondary font-bold uppercase tracking-loose text-red500 bg-transparent outline-none mt-15 lg:mt-0 lg:ml-20 w-full lg:w-auto"
					type="button"
					@click="resetFilters"
				>Reset Filters</button>
			</div>

			<!-- Results Count -->
			<div class="w-full lg:w-1/4 text-center lg:text-right ml-auto">
				<div class="text-center lg:text-left">{{ matches == '' ? 0 : matches }} {{ matches == 1 ? 'Match' : 'Matches' }}</div>


				<button class="outlined-button ml-50"
					v-if="salesDatabase && listings.length"
					@click="getCSV()">
					<span class="outlined-button-content">Export</span>
				</button>
			</div>
		</div>

		<div class="relative">
			<Properties
				:loading="loading"
				:loadingQueued="loadingQueued"
				:listings="listings"
				:orientation="orientation"
				v-infinite-scroll="infiniteLoad"
				class="trans"
				:class="{'opacity-50' : view == 'list' && (loading || loadingQueued)}"
				:view="view"
				@update-map="mapBounding = $event"
				:requested-listing-type="requestedListingType"
				:requested-lease-rate="requestedLeaseRate"
			/>

			<div v-if="!loading && !listings.length && view == 'list'" class="text-gray200 text-4xl font-bold py-100 flex items-center justify-center">
				No listings found, please try another search.
			</div>

			<div v-if="loading && view == 'list'" class="w-full flex justify-center items-center py-80">
				<spinner v-if="loading" :small="true" />
			</div>

			<div v-else-if="(page) % 3 == 0 && !alreadyLoadedThemAll && view == 'list'" class="w-full flex justify-center items-center py-80">
				<a class="filled-button filled-button-red block cursor-pointer" @click="getListings">
					<span class="filled-button-content">Load More</span>
				</a>
			</div>

			<div v-if="alreadyLoadedThemAll && view == 'list' && listings.length > 15" class="text-gray200 text-4xl font-bold py-100 flex items-center justify-center">
				There are no more listings.
			</div>
		</div>

	</section>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import algoliasearch from 'algoliasearch';

const algoliaApplicationId = process.env.ALGOLIA_APPLICATION_ID;
const algoliaSearchKey = process.env.ALGOLIA_SEARCH_APIKEY;
const client = algoliasearch(algoliaApplicationId, algoliaSearchKey);

const scoutIndexPrefix = process.env.SCOUT_INDEX_PREFIX || '';
const index = client.initIndex(scoutIndexPrefix + 'properties');

import infiniteScroll from '../../directives/infinite-scroll';

import Properties from './properties.vue';
import SearchProperties from './search-properties.vue';
import vSelect from '../general/v-select.vue';
import spinner from '../general/spinner.vue';
import toggle from '../general/toggle.vue';
import addCommas from '../../helpers/addCommas';

// Coordinates commercial search state, Algolia requests, CSV export, and views.
export default {
	props: {
		windowSize: { type: String, default: 'md' },
		logoutUrl: { type: String, default: '' },
	},
	directives: {infiniteScroll},
	components: {
		Properties,
		SearchProperties,
		vSelect,
		spinner,
		toggle,
	},
	data() {
		return {
			downloadListings: [],
			listings: [],
			loading: false,
			loadingQueued: true,
			alreadyLoadedThemAll: false,
			matches: 0,
			view: 'list',
			searchValue: '',
			page: 0,
			params: {
				search: {
					query: '',
					options: {}
				},
				query: '',
			},
			sortOption: 'listdate',
			sortDirection: 'desc',
			requestedListingType: null,
			requestedLeaseRate: null,
			widths: {
				xs: 400,
				md: 576,
				md: 768,
				lg: 992,
				xl: 1200
			},
			windowWidth: 0,
			nextURL: '',
			type: '',
			community: '',
			mapBounding: null,
			toggleOptions: {
				'list': 'List',
				'map': 'Map'
			},
			immediate: true,
		};
	},
	watch: {
		params: {
			handler(newValue, oldValue) {
				this.loadingQueued = true
				this.alreadyLoadedThemAll = false
				//console.log(oldValue)
				//console.log(newValue)
				this.queGetListings()
			},
			deep: true,
		},
		sortOption() {
			this.loadingQueued = true
			this.alreadyLoadedThemAll = false
			this.queGetListings()
		},
		sortDirection() {
			this.loadingQueued = true
			this.alreadyLoadedThemAll = false
			this.queGetListings()
		},
		view() {
			this.loadingQueued = true
			this.alreadyLoadedThemAll = false
			this.queGetListings()
		}
	},
	// updated() {
	// 	if (this.windowSize != 'xl' && this.view != 'list') {
	// 		this.view = 'map'
	// 	}
	// },
	methods: {
		getCSV(){

			const promises = [];
			var hits = [];
			this.downloadListings = [];

			var formatter = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD',
			});

			var capitalize = (str) => {
				if(typeof str === 'string')
					return str.charAt(0).toUpperCase() + str.slice(1);
				else if(str) //ugly, I know.. for some reason the csv wouldn't conver these as strings (toString() ) and kept forcing boolean values to all uppercase
					return "True ";
				return "False ";
			}

			var striptags = (string) =>{
				return string
						.replace(/(<(br[^>]*)>)/ig, '\n')
						.replace(/(<([^>]+)>)/ig,'');
			}

			const browser = index.browseAll(
				this.params.search.query,
				{
					...this.params.search.options,
					hitsPerPage: 1000,
					attributesToRetrieve: [
						"title"
						,"status"
						,"listingType"
						,"address"
						,"pricing"
						,"sf"
						,"dateClosed"
						,"objectID"
						,"brokers"
						,"url"
						,"types"
						,"description"
						,"acres"
						,"misc"
						,"settings"
						,"usageFull"
						,"search"
						,"features"
						,"analysis"
					]
				}
			);

			browser.on('result', content => {
				hits = hits.concat(content.hits);
			});

			browser.on('error', err => {
				throw err;
			});

			browser.on('end', () => {
				for (const [i, item] of hits.entries()) {
					promises.push(
						new Promise((resolve) => {
							if(item){

								//flatten the data
								let status = item.status.label;
								let listingType = item.listingType.sale ? 'Sale' : item.listingType.lease ? 'Lease' : '';

								let add1 = item.address.street1;
								let add2 = item.address.street2;
								let city = item.address.city;
								let state = item.address.state;
								let zip = item.address.zip;

								let price = item.pricing.sale && item.pricing.sale.price ? formatter.format(item.pricing.sale.price) : '';
								//let priceSF = item.pricing.sale && item.pricing.sale.sf ? formatter.format(item.pricing.sale.sf) : '';
								let priceLeaseMo = item.pricing.lease ? formatter.format(item.pricing.lease.mo) : '';
								let priceLeaseSf = item.pricing.lease ? formatter.format(item.pricing.lease.sf.min) : '';
								let priceLeaseAdd = item.pricing.lease ? item.pricing.lease.additionalCosts : '';
								let priceLeasUnit = item.pricing.lease ? item.pricing.lease.selectedUnit : '';
								let priceLeaseRate = item.pricing.lease ? formatter.format(item.pricing.lease.sf.min) : '';

								let sfMin = item.sf.min;
								//let sfMax = item.sf.max;

								let type = item.types[0]
								let features = '';

								//placing under try/catch for safety here
								try {
									//convert to an array - we have mixed data here
									features = Object.values(item.features);

									//check for results and adjust delimiter per requests
									if(features != 'undefined' && features.length ){
										features = features.join("; ")
									}
								}
								catch(err) {
									console.log("error " + err.message);
								}


								let dateClosed = new Date(item.dateClosed * 1000);

								//set the array for the csv
								this.downloadListings.push({
									'': i
									,"ID": item.objectID
									,"MLS Number": item.misc.mlsNo
									,"Status": status
									,"Listing Type": listingType
									,"Title": item.title
									,"Address": add1
									,"Addresss 2": add2
									,"City": city
									,"State": state
									,"Zip": zip
									,"County": item.search.county
									,"SF": sfMin
									,"Acres": item.acres
									,"Price": price
									//,Price_SF: priceSF
									,"Lease Rate": priceLeaseRate
									,"Lease Rate Unit": priceLeasUnit
									,"Leasing Rate Month": priceLeaseMo
									,"Leasing Rate per SF": priceLeaseSf
									,"Additional Leasing Costs": priceLeaseAdd
									,"Type": capitalize(type)
									,"Broker": item.brokers
									,"URL": item.url
									,"Cap Rate":item.misc.capRate
									,"Parcel Number": item.misc.parcelNo
									,"Zoning": item.misc.zoning
									,"Year Built": item.misc.buildingYear
									,"Building Description": item.misc.buildingDescription
									,"In Package/Combined Space Only": capitalize(item.settings.inPackageOnly)
									,"Build To Suit": capitalize(item.settings.buildToSuit)
									,"Best Use": item.usageFull ? item.usageFull.best : ""
									,"Permitted Use": item.usageFull ? item.usageFull.permitted : ""
									,"Potential Use": item.usageFull ? item.usageFull.potential : ""
									,"Analysis": item.analysis ? striptags(item.analysis) : ""
									,"Features": features
									,"Description": striptags(item.description)
									,"Date Closed": dateClosed.toLocaleDateString("en-US")
								})
							}

							resolve();
						})
					);
				}

				Promise.all(promises).then(() => {
					this.downloadCsvFile(
						this.downloadListings,
						'PSCRE Sales Database Export (' + new Date().toLocaleDateString('en-US') + ').csv'
					);
				});
			});
		},
		downloadCsvFile(rows, filename) {
			const csv = this.convertRowsToCsv(rows);
			const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
			const url = URL.createObjectURL(blob);
			const link = document.createElement('a');

			link.href = url;
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(url);
		},
		convertRowsToCsv(rows) {
			if (!rows.length) {
				return '';
			}

			const headers = Object.keys(rows[0]);
			const lines = [
				headers.map(this.escapeCsvValue).join(','),
				...rows.map(row => headers.map(header => this.escapeCsvValue(row[header])).join(',')),
			];

			return lines.join('\n');
		},
		escapeCsvValue(value) {
			if (value == null) {
				return '';
			}

			const stringValue = String(value);
			const escaped = stringValue.replace(/"/g, '""');

			return /[",\n\r]/.test(escaped) ? '"' + escaped + '"' : escaped;
		},
		getHashParam(name) {
		    var url = window.location.search;
		    name = name.replace(/[\[\]]/g, '\\$&');
		    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		        results = regex.exec(url);
		    if (!results) return null;
		    if (!results[2]) return '';
		    return decodeURIComponent(results[2].replace(/\+/g, ' '));
		},
		resetFilters() {
			if (this.$refs.searchProperties) {
				this.$refs.searchProperties.resetFilters();
			}
		},
		getSearchParam(name) {
		    name = name.replace(/[\[\]]/g, '\\$&');
		    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		        results = regex.exec(this.params.search);
		    if (!results) return null;
		    if (!results[2]) return '';
		    return decodeURIComponent(results[2].replace(/\+/g, ' '));
		},
		infiniteLoad() {
			if ((this.page) % 3 && this.view == 'list') {
				this.getListings()
			}
		},
		getListings({ clear } = {}) {
			var vm = this

			var mapView = (this.view != 'list')

			if (clear) {
				this.page = 0
			}

			if (this.alreadyLoadedThemAll) {
				this.loading = false
			}

			if (!this.loading && !this.alreadyLoadedThemAll) {

				this.loading = true

				let url = '?view=' + this.view + '&'
				url += this.params.query;
				url += 'sort=' + this.sortOption + '&direction=' + this.sortDirection + '&'

			//	window.location.hash = url.replace(/%2C/g,",")

				var currentUrl = url.replace(/%2C/g,",");

				// Update the hash
				window.history.replaceState(null, null, `${currentUrl}`);

				client.initIndex(this.sortOption + '_' + this.sortDirection).search(
					this.params.search.query,
					{
						page: this.page,
						...this.params.search.options,
						...(mapView && {
							hitsPerPage: 1000
						})
					},
					(err, { hits, nbHits, page, nbPages } = {}) => {
						if (err) throw err;

						this.loading = false
						this.loadingQueued = false

						this.matches = addCommas(nbHits)

						if (page + 1 == nbPages) {
							this.alreadyLoadedThemAll = true;
						} else {
							this.page ++
						}

						if (clear) {
							this.listings = hits;
						} else {
							this.listings = this.listings.concat(hits)
						}

						this.requestedListingType = this.getHashParam('listingtype')
						this.requestedLeaseRate = this.getHashParam('leaserate')

						if (!this.requestedListingType && this.sortOption == 'listprice') {
							this.sortOption = 'listdate'
						}

						this.immediate = false
					}
				);
			}
		},
		queGetListings() {
			if (this.immediate) {
				this.getListings({clear: true})
			} else {
				this.debounceListings()
			}
		},
		debounceListings: _.debounce(
			function() {
				this.getListings({clear: true})
			},
			// This is the number of milliseconds we wait for the user to stop typing.
			2000
		),
	},
	computed: {
		orientation() {
			if (this.windowSize == 'xs' || this.view != 'list') {
				return 'vertical'
			} else {
				return 'horizontal'
			}
		},
		sortDirections() {
			if (this.sortOption == 'listdate' || this.sortOption == 'closeddate') {
				var sortDirections = {
					'desc': "Newest",
					'asc': "Oldest"
				}
			} else {
				var sortDirections = {
					'desc': "High to Low",
					'asc': "Low to High"
				}
			}
			return sortDirections
		},
		salesDatabase() {
			return window.location.pathname.substr(1) == 'sales'
		},
		sortOptions() {
			return {
				...(this.salesDatabase && {'closeddate': 'Closed Date'}),
				...(this.requestedListingType && {'listprice': 'Price'}),
				'listdate': 'List Date',
				'acres': 'Acres',
				'area': 'Sqft',
			}
		},
		hasActiveFilters() {
			return this.params.query.length > 0;
		},
	},
	mounted() {
		const urlParams = new URLSearchParams(window.location.search);

		const view = urlParams.get('view');
		if (view) {
			this.view = view;
		}

		const sortOption = urlParams.get('sort');
		if (sortOption) {
			this.sortOption = sortOption;
		}

		const sortDirection = urlParams.get('direction');
		if (sortDirection) {
			this.sortDirection = sortDirection;
		}

		if (this.params.search.query == "") {
			this.getListings();
		}

		if (this.salesDatabase) {
			this.sortOption = 'closeddate'
		}
	},
};
</script>

<style scoped>
.border-white-30 {
	border-color: rgba(255, 255, 255, 0.3);
}
</style>
